document.addEventListener("DOMContentLoaded", function () {
  const quantitySelectors = document.querySelectorAll(
    ".Quantity_Selector_Inputs"
  );
  quantitySelectors.forEach(registerQuantitySelector);

  function registerQuantitySelector(selector) {
    const quantityInput = selector.querySelector("input");
    const quantityMinus = selector.querySelector(".Quantity_Selector_Minus");
    const quantityPlus = selector.querySelector(".Quantity_Selector_Plus");

    quantityMinus.addEventListener("click", function () {
      if (quantityInput.value > 1 || quantityInput.closest(".Cart_Item")) {
        quantityInput.value--;
      }
      quantityInput.dispatchEvent(new Event("change"));
    });

    quantityPlus.addEventListener("click", function () {
      quantityInput.value++;
      quantityInput.dispatchEvent(new Event("change"));
    });
  }

  subscribe(PUB_SUB_EVENTS.contentAdded, function (data) {
    const quantitySelectors = data.content.querySelectorAll(
      ".Quantity_Selector_Inputs"
    );
    quantitySelectors.forEach(registerQuantitySelector);
  });
});
